<template>
  <div class="article-card-list">
    <div class="item-article" :class="{ margin: showCommonCard }" v-for="(item, index) in list" :key="item.id">
      <ArticleCard v-if="showCommonCard" :article="item" />
      <ArticleCardSm v-else :article="item" :border="index !== list.length - 1" />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import ArticleCard from './article-card.vue';
import ArticleCardSm from './article-card-sm.vue';

@Component({
  components: {
    ArticleCard,
    ArticleCardSm,
  }
})
export default class ArticleListCard extends Vue {
  @Prop({ type: Array, default: () => [] }) list;
  @Prop({ type: String }) cardType; // common || sm

  get showCommonCard() {
    if (this.cardType) {
      return this.cardType === 'common';
    }
    return ['SpecialColumn'].includes(_.get(this.list, '0.type'));
  }
}
</script>

<style lang="scss" scoped>
  .article-card-list {
    .item-article {
      &.margin {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
</style>
